import React from "react";
import { Provider } from 'react-redux';
import packageStore from '../common/store/package_store';
import WithAppTopContexts from "../common/components/with_app_top_contexts";
import Index from './components/index.js';

const App = (props) => {
  return (
    <Provider store={ packageStore }>
      <WithAppTopContexts initProps={ props }>
        <Index { ...props } />
      </WithAppTopContexts>
    </Provider>
  );
};

export default App;
